// extracted by mini-css-extract-plugin
export default {"header":"styles_header__su2bv","header__wrap":"styles_header__wrap__XV8zW","header__user":"styles_header__user__1j+vt"};